module.exports = __webpack_public_path__ + "static/media/Nepeo.56cc6078.jpeg";